export const SEND_EMAIL_SAGA = 'SEND_EMAIL_SAGA';